import React, { useEffect, useState } from "react";
import Table from "../shared/table/Table";
import { FiEdit3 } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import { fetchFormData, loanSegmentOptions } from "../../utils/options";
import { MdThumbDown, MdThumbUp } from "react-icons/md";
import topTost from "../../utils/topTost";
import Swal from "sweetalert2";

const Loan_TypeTable = ({ permission }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");
  const [userData, setUserData] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  const fetchAllData = async () => {
    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("moduleId", M_id);

    try {
      Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const result = await fetchFormData("list-loan-types", formData, "POST");

      if (result) {
        const user = result.data;
        setUserData(user || []);
      }
    } catch (error) {
      console.error("Error fetching loan types:", error);
      Swal.fire("Error", "Failed to fetch loan types", "error");
    } finally {
      Swal.close(); // Ensure loader closes even on error
    }
  };

  const toggleStatus = async (Id) => {
    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("moduleId", M_id);
    const result = await fetchFormData(
      `loan-type/toggle-status/${Id}`,
      formData,
      "POST"
    );

    if (result && result.code === 200) {
      await fetchAllData();
      if (result && result.status === 1) {
        topTost({
          title: "Status updated successfully : Active",
          icon: "success",
        });
      } else {
        topTost({
          title: "Status updated successfully : Deactive",
          icon: "success",
        });
      }
    } else {
      console.error("Failed to toggle status:", result.message);
    }
  };

  const columns = [
    ...(permission?.pf_edit === 1 || permission?.pf_status === 1
      ? [
          {
            accessorKey: "actions",
            header: () => "Actions",
            cell: ({ row }) => {
              const id = row.original.id;
              const is_active = row.original.status;
              return (
                <div className="hstack gap-2 justify-content-end">
                  {permission?.pf_edit === 1 && (
                    <span
                      className="cursor-pointer"
                      onClick={() =>
                        navigate(`/master/edit-inquiry-type/${id}?id=${M_id}`)
                      }
                    >
                      <FiEdit3 size={16} />
                    </span>
                  )}
                  {permission?.pf_status === 1 &&
                    (is_active === 1 ? (
                      <MdThumbUp
                        className="cursor-pointer text-success"
                        onClick={() => toggleStatus(id)}
                      />
                    ) : (
                      <MdThumbDown
                        className="cursor-pointer text-secondary"
                        onClick={() => toggleStatus(id)}
                      />
                    ))}
                </div>
              );
            },
            meta: {
              headerClassName: "width-30",
              exportable: false,
            },
          },
        ]
      : []),

    {
      accessorKey: "loan_type_name",
      header: () => "inquiry type",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },

    {
      accessorKey: "loan_segment",
      header: "inquiry Segment",
      cell: (info) => {
        const value = info.getValue();
        const segment = loanSegmentOptions.find(
          (option) => option.value === value
        );
        return segment ? segment.label : "-";
      },
      defaultIsVisible: true,
    },
    {
      accessorKey: "status",
      header: () => "Status",
      cell: (info) => {
        const val = info.getValue(); // expected to be 1 or 0 (number)
        const isActive = val === 1;

        const label = isActive ? "Active" : "Deactive";
        const styles = {
          backgroundColor: isActive ? "#cce5ff" : "#fff3cd", // Sky blue / Light yellow
          color: isActive ? "#004085" : "#856404", // Dark blue / Dark yellow
          padding: "4px 10px",
          display: "inline-block",
          fontWeight: "bold",
          fontSize: "12px",
          textAlign: "center",
        };

        return <span style={styles}>{label}</span>;
      },
      defaultIsVisible: true,
    },
  ];

  useEffect(() => {
    fetchAllData();
  }, []);
  return (
    <>
      <Table data={userData} columns={columns} />
    </>
  );
};

export default Loan_TypeTable;
